// extracted by mini-css-extract-plugin
module.exports = {"menu_group":"MenuGroup_menu_group__prQ8q","menu_group_container":"MenuGroup_menu_group_container__1oIrf","menu_group_caption":"MenuGroup_menu_group_caption__1njc_"};